import React from "react";
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import {Link} from "react-router-dom";
import "./ApplianceComponents.css";
import {vscodeDark} from "@uiw/codemirror-theme-vscode";
import {langs} from "@uiw/codemirror-extensions-langs";
import ReactCodeMirror from "@uiw/react-codemirror";
import toast from "react-hot-toast";

type ApplianceComponentsProperties = {}

type ApplianceComponent = {
    imageReference: string
    friendlyName: string
    version: string
}

type ApplianceComponentsState = {
    applianceComponents: Array<ApplianceComponent>
    showUploadDialog: boolean
    dockerImage: File | null
}

class ApplianceComponents extends React.Component<ApplianceComponentsProperties, ApplianceComponentsState> {
    private updateIntervalId: number | undefined;

    constructor(props: ApplianceComponentsProperties) {
        super(props);
        this.state = {
            applianceComponents: new Array<ApplianceComponent>(),
            showUploadDialog: false,
            dockerImage: null
        }
    }

    componentDidMount() {
        this.fetchApplianceComponents();
        this.updateIntervalId = window.setInterval(() => this.fetchApplianceComponents(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.updateIntervalId);
    }


    private uploadApplianceComponent = () => {
        let data = new FormData();
        data.append('image', this.state.dockerImage!)

        this.setState({
            showUploadDialog: false,
            dockerImage: null
        });

        const response  = fetch(getApiUrl() + "/v1/component/appliance/", {
            method: "POST",
            headers: [
                ["Authorization", authService.authHeader()]
            ],
            body: data
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Failed to upload appliance component")
            }
        });

        const _ = toast.promise(response, {
            loading: 'Uploading appliance component...',
            success: 'Appliance component uploaded',
            error: 'Failed to upload appliance component'
        });
    }

    render() {
        return (
            <div className="ApplianceComponents">
                <h2>Appliance Components</h2>

                {this.state.applianceComponents.length > 0 ? <div className="ApplianceComponents-list">
                    {this.state.applianceComponents.map((component) => {
                        return (
                            <Link to={"/component/appliance/" + component.imageReference + "/" + component.version}
                                  className="ApplianceComponents-component" key={component.imageReference + component.version}>
                                {component.friendlyName}<small
                                className="ApplianceComponents-friendlyName">{component.version}</small>
                            </Link>);
                    })}
                </div> : <div className="ApplianceComponents-list">
                    <div className="ApplianceComponents-empty">No appliance components found</div>
                </div>}
                <button className="Home-link" onClick={() => this.setState({showUploadDialog: true})}>Upload appliance
                    component
                </button>
                {this.state.showUploadDialog && <div className="ApplianceComponents-upload">
                    <div className="ApplianceComponents-upload-content">
                        <h5>Docker image (tar archive)</h5>
                        <input type="file" accept=".docker"
                               onChange={(e) => this.setState({dockerImage: e.target.files![0]})}/>
                        <div className="Endpoints-newEndpoint-buttons">
                            <button onClick={this.uploadApplianceComponent}
                                    disabled={this.state.dockerImage === null}>Upload
                            </button>
                            <button onClick={() => this.setState({
                                showUploadDialog: false,
                                dockerImage: null
                            })}>Cancel
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    private fetchApplianceComponents() {
        fetch(getApiUrl() + "/v1/component/appliance/", {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<ApplianceComponent[]>)
            .then((response) => {
                this.setState({
                    applianceComponents: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export default ApplianceComponents;
